import { all } from "redux-saga/effects";

import staticSaga from "./static/saga";
import authSaga from "modules/Auth/saga";
import homepageSaga from "modules/Homepage/saga";
import personnelInformationSaga from "modules/PersonnelInformation/saga";
import workPerformanceSaga from "modules/WorkPerformance/saga";
import declareLeaveSaga from "modules/DeclareLeave/saga";
import personnelFormSaga from "modules/PersonnelForm/saga";
import regulationsSaga from "modules/Regulations/saga";
import internalCultureSaga from "modules/InternalCulture/saga";
import layoutSaga from "layouts/Sidenav/saga";
import newsSaga from "modules/News/saga";
import researchReportSaga from "modules/ResearchReport/saga";
import operationProcessSaga from "modules/OperationProcess/saga";
import internalDocumentSaga from "modules/InternalDocuments/saga";
import authorizationDocumentSaga from "modules/AuthorizationDocument/saga";
import eventSaga from "modules/Event/saga";
import birthdaySaga from "modules/Birthday/saga";
import notificationSaga from "modules/Notification/saga";
import recruitmentSaga from "modules/Recruitment/saga";
import evaluationSaga from "modules/Evaluation/saga";
import salarySaga from "modules/Salary/saga";

export default function* rootSaga() {
  yield all([
    authSaga(),
    homepageSaga(),
    personnelInformationSaga(),
    workPerformanceSaga(),
    declareLeaveSaga(),
    personnelFormSaga(),
    regulationsSaga(),
    internalCultureSaga(),
    layoutSaga(),
    newsSaga(),
    researchReportSaga(),
    operationProcessSaga(),
    staticSaga(),
    internalDocumentSaga(),
    authorizationDocumentSaga(),
    eventSaga(),
    birthdaySaga(),
    notificationSaga(),
    recruitmentSaga(),
    evaluationSaga(),
    salarySaga(),
  ]);
}
